export const diagnosisSurveyMapping: Array<SurveyMapping> = [
  {
    code: 'F5089',
    value: 'Other specified feeding or eating disorder (OSFED)',
  },
  { code: 'J302', value: 'Seasonal allergies' },
  { code: 'K900', value: 'Celiac' },
  { code: 'F50029', value: 'Anorexia nervosa - binge/purge type' },
  { code: 'F5001', value: 'Anorexia nervosa - restricting type' },
  { code: 'F5020', value: 'Bulimia nervosa' },
  { code: 'F5082', value: 'Avoidant restrictive food intake disorder (ARFID)' },
  { code: 'F50819', value: 'Binge eating disorder (BED)' },
  { code: 'F983', value: 'Pica' },
  { code: 'F9821', value: 'Rumination (regurgitation) disorder' },
  { code: 'F909', value: 'ADHD' },
  { code: 'F319', value: 'Bipolar' },
  { code: 'F429', value: 'OCD' },
  { code: 'F4310', value: 'PTSD' },
  { code: 'F411', value: 'Generalized Anxiety' },
  { code: 'F4010', value: 'Social Phobia' },
  { code: 'F4001', value: 'Panic Disorder with Agoraphobia' },
  // food allergies
  { code: 'Z91011', value: 'Dairy' },
  { code: 'Z91012', value: 'Egg' },
  { code: 'Z91013', value: 'Fish' },
  { code: 'Z91013', value: 'Shellfish' },
  { code: 'Z91010', value: 'Peanut' },
  { code: 'Z91018', value: 'Tree nuts' },
  { code: 'Z91018', value: 'Wheat' },
  { code: 'Z91018', value: 'Soy' },
  { code: 'Z91018', value: 'Gluten (un-diagnosed with celiac)' },
];
